// Titan Speed Scan - Image embedding card identification
// Uses cardresearch Supabase Edge Function with Amazon Titan embeddings + pgvector

const TITAN_ENDPOINT = 'https://dpbwqvmiocwkalqbbhbb.supabase.co/functions/v1/titan-identify';
const TITAN_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRwYndxdm1pb2N3a2FscWJiaGJiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzk5MDY0ODQsImV4cCI6MjA1NTQ4MjQ4NH0.Zg41oXFk47lbipSVz4zC8xy-nAqcPU0shr17_HZuT2Y';

// Resize image to 245px wide, preserving aspect ratio
// Reference embeddings were built from 245x337 TCGdex images (native card shape)
function resizeToCanvas(dataUrl, maxW = 245) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    // Guard against a hung load: if the image never fires load/error
    // (e.g. a malformed src), reject so the caller can surface an error
    // instead of leaving the card stuck "identifying" forever.
    const timer = setTimeout(() => {
      reject(new Error('Image load timed out'));
    }, 15000);
    img.onload = () => {
      clearTimeout(timer);
      const srcW = img.width;
      const srcH = img.height;
      const targetW = Math.min(maxW, srcW);
      const targetH = Math.round((targetW / srcW) * srcH);
      const canvas = document.createElement('canvas');
      canvas.width = targetW;
      canvas.height = targetH;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, targetW, targetH);
      resolve(canvas.toDataURL('image/jpeg', 0.85).split(',')[1]);
    };
    img.onerror = () => {
      clearTimeout(timer);
      reject(new Error('Failed to load image for identification'));
    };
    img.src = dataUrl;
  });
}

export async function titanIdentify(dataUrl, matchCount = 5, lang = 'en') {
  const base64 = await resizeToCanvas(dataUrl);

  const response = await fetch(TITAN_ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${TITAN_ANON_KEY}`,
    },
    body: JSON.stringify({
      image: base64,
      match_count: matchCount,
      lang,
    }),
  });

  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.error || `Titan API error: ${response.status}`);
  }

  const data = await response.json();
  console.log('[Titan] Response:', data.matches?.length, 'matches in', data.timing?.total_ms + 'ms');
  return data.matches || [];
}
